module.exports = __webpack_public_path__ + "img/emoji_sorrir.6f1b3f73.png";